import { createContext, useContext, useEffect, useState } from "react";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", nativeLabel: "English" },
];

const LanguageContext = createContext(null);
export const useLanguage = () => useContext(LanguageContext);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const stored = window.localStorage.getItem("od_language");
    return SUPPORTED_LANGUAGES.some((item) => item.code === stored) ? stored : "en";
  });

  useEffect(() => {
    document.documentElement.lang = language;
    window.localStorage.setItem("od_language", language);
  }, [language]);

  const changeLanguage = (code) => {
    if (SUPPORTED_LANGUAGES.some((item) => item.code === code)) setLanguage(code);
  };

  return (
    <LanguageContext.Provider value={{ language, languages: SUPPORTED_LANGUAGES, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}
